<div class="dialog-content-max">
    <form [formGroup]="requestform">
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="name" class="required-label">{{verticalLabel}} Name<span class="maxchars">(Max 100 chars)</span><span>*</span></label>
                <input type="text" class="form-control" id="name" inputId="name" placeholder="Enter {{verticalLabel}} Name" name="name" formControlName="name" required>
                <span class="errormessage" *ngIf="requestform.get('name').invalid && (requestform.get('name').touched || requestform.get('name').dirty)">
                    {{ getErrorMessage(requestform, validation_message, 'name') }}
                </span>
            </div>
             <div class="field col-12" *ngIf="isEdit">
            <label for="activeflag" class="required-label">Active Flag<span>*</span></label> 
            <p-dropdown [options]="activeFlag" inputId="activeflag" [filter]="true" appendTo="body" name="activeflag"
                optionLabel="labelname" optionValue="value" placeholder="Select Flag" formControlName="activeflag"></p-dropdown>
   
        </div>
        </div>
       
    </form>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Close" styleClass="customeclose"  (click)="closemodal(requestform,this.ref,'Are you sure you want to close?')" ></p-button>
        <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave" 
            (click)="add()" >
        </p-button>
    </div>
</div>
